import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Header from "./components/Layout/Header"
import Footer from "./components/Layout/Footer"
import HomePage from "./pages/HomePage"
import QuienesSomos from "./pages/QuienesSomos"
import Contacto from "./pages/Contacto"
import PublicProductList from "./components/Public/PublicProductList"
import LoginPage from "./pages/LoginPage"
import RegisterPage from "./pages/RegisterPage"
import PanelPage from "./pages/PanelPage"
import ProtectedRoute from "./hooks/auth/ProtectedRoute"

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="/productos" element={<PublicProductList />} />
        <Route path="/quienes-somos" element={<QuienesSomos />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/panel" element={<PanelPage />} />
        </Route>

        <Route path="*" element={<HomePage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}
